import { render, staticRenderFns } from "./PriceRangeSlider.vue?vue&type=template&id=53ade303&scoped=true&"
import script from "./PriceRangeSlider.vue?vue&type=script&lang=js&"
export * from "./PriceRangeSlider.vue?vue&type=script&lang=js&"
import style0 from "./PriceRangeSlider.vue?vue&type=style&index=0&id=53ade303&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ade303",
  null
  
)

export default component.exports